import { TrackingContext } from '@change-corgi/core/react/tracking';
import { Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import type { Comment } from 'src/app/pages/petition/comments/pageContext';
import { CommentDelete, CommentLikes, CommentReportAbuse, CommentShares } from 'src/app/shared/components/comments';
import { Join } from 'src/app/shared/components/layout/misc';

import { useCommentFooter } from './hooks/useCommentFooter';

type Props = {
	comment: Comment;
};

export function CommentFooter({ comment }: Props) {
	const {
		data: { canReport, canDelete, petition, trackingProperties, showShareActions },
		actions: { handleBeforeDeleteComment, handleDeletedComment, handleLikeToggle },
	} = useCommentFooter(comment);

	return (
		<Flex sx={{ gap: 16, justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap' }}>
			<Flex sx={{ gap: 16, alignItems: 'center' }}>
				<TrackingContext properties={trackingProperties}>
					<CommentLikes comment={comment} onLikeToggled={handleLikeToggle} />
				</TrackingContext>
				{showShareActions && (
					<CommentShares comment={comment} petition={petition} viewContext="petitions_comments_index" size="small" />
				)}
			</Flex>
			<Flex sx={{ alignItems: 'center' }}>
				<Join
					separator={
						<Text color="neutral-grey600" mx={8}>
							·
						</Text>
					}
				>
					{canDelete && (
						<TrackingContext properties={trackingProperties}>
							<CommentDelete
								size="large"
								color="neutral-grey600"
								comment={comment}
								onBeforeDelete={handleBeforeDeleteComment}
								onDeleted={handleDeletedComment}
							/>
						</TrackingContext>
					)}
					{canReport && <CommentReportAbuse size="caption" comment={comment} petition={petition} />}
				</Join>
			</Flex>
		</Flex>
	);
}
